import React, { Component } from "react";
import { Form, Radio, Input, Slider } from "antd";
import styles from "../index.module.less";
import { observer } from "mobx-react";

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const marks = {
	0: "0",
	1: "1",
	2: "2",
	3: "3",
	4: "4",
	5: "5",
	6: "6",
	7: "7",
	8: "8"
};

@observer
class TheBestSpinner extends Component {
	render() {
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label="Username">
					{this.props.form.getFieldDecorator("tbs.username")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem label="Password">
					{this.props.form.getFieldDecorator("tbs.password")(
						<Input type="text" />
					)}
				</FormItem>
				<FormItem label="Quality">
					{this.props.form.getFieldDecorator("tbs.quality")(
						<RadioGroup>
							<RadioButton value={1}>Best</RadioButton>
							<RadioButton value={2}>Better</RadioButton>
							<RadioButton value={3}>Good</RadioButton>
						</RadioGroup>
					)}
				</FormItem>
				<FormItem label="Maximum Synonyms">
					{this.props.form.getFieldDecorator("tbs.maxSyns")(
						<Slider min={1} max={8} style={{ width: 400 }} marks={marks} />
					)}
				</FormItem>
			</Form>
		);
	}
}

export default TheBestSpinner;
